const LOADING_CLASS = "is-loading";

function getSettings() {
	const settings = window.creditbarBlog;

	if (!settings || !settings.ajaxUrl || !settings.nonce) {
		return null;
	}

	return settings;
}

function initLoadMore() {
	const button = document.querySelector("[data-blog-load-more]");
	const grid = document.querySelector("[data-blog-grid]");
	const settings = getSettings();

	if (!button || !grid || !settings) {
		return;
	}

	button.addEventListener("click", () => {
		if (button.classList.contains(LOADING_CLASS)) {
			return;
		}

		const offset = Number.parseInt(button.dataset.offset, 10) || 0;
		const categoryId = button.dataset.categoryId || "0";
		const authorId = button.dataset.authorId || "0";

		const formData = new FormData();
		formData.append("action", "creditbar_blog_load_more");
		formData.append("nonce", settings.nonce);
		formData.append("offset", String(offset));
		formData.append("category_id", categoryId);
		formData.append("author_id", authorId);

		button.classList.add(LOADING_CLASS);
		button.setAttribute("aria-busy", "true");

		fetch(settings.ajaxUrl, {
			method: "POST",
			credentials: "same-origin",
			body: formData,
		})
			.then((response) => response.json())
			.then((response) => {
				const data = response && response.success ? response.data : null;
				const html = data && data.html ? data.html : "";
				const count = data && data.count ? data.count : 0;

				if (!html.trim() || count === 0) {
					button.remove();

					return;
				}

				grid.insertAdjacentHTML("beforeend", html);
				button.dataset.offset = String(offset + count);

				if (!data.has_more) {
					button.remove();
				}
			})
			.catch(() => {
				button.remove();
			})
			.finally(() => {
				button.classList.remove(LOADING_CLASS);
				button.removeAttribute("aria-busy");
			});
	});
}

document.addEventListener("DOMContentLoaded", initLoadMore);
